import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './marketing.component.html',
    standalone: false
})
export class MarketingPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection;
  public description: string;
  public links: any[];

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.description = this.plugin.config.Description;
    this.links = this.plugin.config.Links;
    this.cdRef.detectChanges();
  }

  navigateTo(url) {
    window.open(url, '_blank').focus();
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'marketing',
      'edit'
    ];
  }
}

PluginComponent.plugins['marketing'] = MarketingPluginComponent;
